/* RESPONSIBLE TEAM: team-inbox-management */
import StepSerializer from '../step';

export default StepSerializer;
